<mat-card class="content-card">
  <div class="summary-header">
    <div>
      <mat-card-title>
        {{ "MDB Energy Summary (This Month)" | translate }}
      </mat-card-title>

      <!-- <div class="summary-total">
        {{ "view_value.total_energy" | translate }}:
        <strong> {{ totalEnergy | number }} kWh </strong>

        <strong>100%</strong>
      </div> -->
    </div>

    <!-- <button
      type="button"
      mat-flat-button
      class="csv-button"
      (click)="csvClick.emit()"
      data-html2canvas-ignore="true"
    >
      <mat-icon>download</mat-icon>
      CSV
    </button> -->
  </div>

  <mat-card-content>
    <div class="table-container">
      <table mat-table [dataSource]="items" class="energy-table">
        <!-- index -->
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>

          <td mat-cell *matCellDef="let item; let i = index">
            {{ i + 1 }}
          </td>

          <td mat-footer-cell *matFooterCellDef>
            <strong>Total</strong>
          </td>
        </ng-container>

        <!-- name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ "view_value.group" | translate }}
          </th>

          <td mat-cell *matCellDef="let item">
            {{ item.name }}
          </td>

          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- energy -->
        <ng-container matColumnDef="energy">
          <th mat-header-cell *matHeaderCellDef>
            {{ "view_value.total_energy_kwh" | translate }}
          </th>

          <td mat-cell *matCellDef="let item">
            {{ item.energy | number }}
          </td>

          <td mat-footer-cell *matFooterCellDef>
            <strong>{{ totalEnergy | number }}</strong>
          </td>
        </ng-container>

        <!-- total energy cost -->
        <ng-container matColumnDef="totalEnergyCost">
          <th mat-header-cell *matHeaderCellDef>
            {{ "view_value.total_energy_cost" | translate }}
          </th>

          <td mat-cell *matCellDef="let item">
            {{ calUsedEnergy(item.energy) | number: "1.2-2" }}
          </td>

          <td mat-footer-cell *matFooterCellDef>
            <strong>
              {{ calUsedEnergy(totalEnergy) | number: "1.2-2" }}
            </strong>
          </td>
        </ng-container>

        <!-- proportion -->
        <ng-container matColumnDef="proportion">
          <th mat-header-cell *matHeaderCellDef>
            {{ "view_value.proportion" | translate }}
          </th>

          <td mat-cell *matCellDef="let item">{{ item.proportion }}%</td>

          <td mat-footer-cell *matFooterCellDef>
            <strong>100%</strong>
          </td>
        </ng-container>

        <!-- emission -->
        <ng-container matColumnDef="emission">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-with-hint">
              <span>
                {{ "view_value.emission" | translate }}
              </span>

              <span class="hint-wrapper">
                <mat-icon class="hint-icon">help_outline</mat-icon>

                <div class="hint-popup">
                  <a
                    href="https://tver.tgo.or.th/database/public-document/announcement?lang=th&utm_source"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hint-link"
                  >
                    Emission Referent
                    <mat-icon>open_in_new</mat-icon>
                  </a>
                </div>
              </span>
            </div>
          </th>

          <td mat-cell *matCellDef="let item">
            {{ calEmission(item.energy) | number: "1.2-2" }}
          </td>

          <td mat-footer-cell *matFooterCellDef>
            <strong>
              {{ calEmission(totalEnergy) | number: "1.2-2" }}
            </strong>
          </td>
        </ng-container>

        <!-- rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          mat-footer-row
          *matFooterRowDef="displayedColumns"
          class="total-row"
        ></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
